import { Adyen } from '@quickmd-llc/design-system'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

export function useAdyenIsEnabled() {
  const adyenFlagObject = useSelector((s: Store) => s.flags.flags.adyen)

  const { state } = useLocation()

  const bookingId =
    state && typeof state === 'object' && 'bookingId' in state && typeof state.bookingId === 'string' ?
      state.bookingId
    : null

  const newVisit = useSelector((s: Store) => s.newVisitReducer.visits[bookingId])

  const patientCreateDateTimeUtc = newVisit?.selectedPatient?.CreateDateTimeUtc
  const lastName = newVisit?.selectedPatient?.LastName
  const patientId = newVisit?.selectedPatient?.PatientId

  return Adyen.getAdyenIsEnabled({ adyenFlagObject, patientCreateDateTimeUtc, lastName, patientId })
}
